import React from 'react';
import ReactTooltip from 'react-tooltip';


const colors = {
  success: '#39cd33',
  warning: '#eae825',
  danger: '#e41b1d',
  purple: '#820ad1',
  orange: '#ff873d',
  white: '#FFFFFF'
};

const tips = {
  success: "Limite de Crédito Disponível e atualizado nos últimos 12 meses. Previsão será reanalisada após a entrada de pedidos.",
  warning: "Solicitar reanalise de crédito.",
  danger: "Cliente com duplicatas em atraso. Valor apresentado é o valor em atraso.",
  purple: "Crédito Suspenso. Venda no momento condicionada a pagamento antecipado ou cartão.",
  orange: "Sem faturamentos, ou mais de 12 meses sem comprar. Solicitar análise de crédito.",
  white: ""
}

const getColorFromValue = (value) => {
  switch(value) {
    case 0:
      return colors.success;
    case 1:
      return colors.warning;
    case 2:
      return colors.orange;
    case 3:
      return colors.purple;
    case 4:
      return colors.danger;
    default:
      return colors.white;
  }
}

const getTipFromValue = (value) => {
  switch(value) {
    case 0:
      return tips.success;
    case 1:
      return tips.warning;
    case 2:
      return tips.orange;
    case 3:
      return tips.purple;
    case 4:
      return tips.danger;
    default:
      return tips.white;
  }
}

const SemaforoFormatter = (props) => {
  const { value, isLimitless } = props;
  const size = props.size ? `${props.size}px` : '5px'
  const maxWidth = props.size ? `${props.size*2}px` : '10px'

  return (
    <>
      <ReactTooltip multiline class="toolTip" />
      <div
        data-tip={getTipFromValue(value)}        
        style={{
          maxWidth: isLimitless ? 'none' : maxWidth,
          padding: '6px',
          paddingBottom: size,
          marginRight: '2px',
          borderRadius: '4px',
          borderStyle: 'solid',
          borderWidth: '1px',
          backgroundColor: getColorFromValue(value),
        }}
      >
      </div>
    </>
  );
}

export default SemaforoFormatter;
